import { useEffect, useState } from 'react';

import { useAuthStore } from '@/stores/auth';

/**
 * Сессия восстановлена из хранилища? В браузере это происходит мгновенно, в
 * приложении — через плагин, поэтому нужен явный признак готовности.
 *
 * Вынесено из `app/router.tsx` 14.09.2026: тот же признак нужен входу приложения
 * (`pages/guest/StoreEntry.tsx`) — иначе вошедший ученик на секунду видел бы
 * гостевую главную, пока хранилище читается.
 */
export function useSessionReady(): boolean {
  const [ready, setReady] = useState(() => useAuthStore.persist.hasHydrated());
  useEffect(() => {
    if (ready) return;
    return useAuthStore.persist.onFinishHydration(() => setReady(true));
  }, [ready]);
  return ready;
}
